import React, {useEffect} from "react";
import {usePageViewTracking} from "../features/analytics/Analytics";

const NoInviteContent = ({t}) => {
    const trackView = usePageViewTracking();
    useEffect(() => {
        trackView("No Invite");
    }, [trackView]);
    return (
        <main>
            <p>{t("noInvite")}</p>
        </main>
    );
}


export default NoInviteContent;
